/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/**
 * MyCleo Site
 */

 /** Unique tabs using H6 as an anchor **/
$($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
  	
    var tabName = $(this).text();
    tabContent = '';
    
    //check if h6 has text inside
   if ($(this).text() != '') {
        
        //hide h6
      $(this).hide();

        //combine content between H6 elements
      $(this).nextUntil('h6').each(function() {
          tabContent = tabContent + this.outerHTML;
            
            //hide content
          $(this).hide();
      });
      
        //generate tab HTML
      $('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
      $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');

  } else {	

        //hide empty H6
        $(this).hide();
  }
});

var MyCleo = {
    Blog : {
        prettyBlock: function(){
            if((jQuery(window).width() > 768) && (jQuery('.home-blog__items').length > 0)){
               var postsObj = jQuery('.home-blog__items').find('.o-layout__item');
               if(postsObj.length> 0){
                   var obj;
                   var maxHeight = 0, titleHeight = 0;
                   postsObj.each(function(index){
                       obj = jQuery(this);
                       titleHeight = obj.find('.blog__title').height();
                       if(titleHeight > maxHeight){
                           maxHeight = titleHeight;
                       }
                   });
                   if(maxHeight > 0){
                       postsObj.each(function(index){
                           jQuery(this).find('.blog__title').css({
                               'min-height': maxHeight
                           });
                       });
                   }
               }
            }
        }
    }
};


jQuery(document).ready(function(){
   //Set pretty bock item for blog on home page
  MyCleo.Blog.prettyBlock();
  var _productText = '<div class="product-single__content-text-mobile">'+$('#shopify-section-product-template .product-single__content-text').html()+'</div>';
  $(_productText).insertAfter($('#shopify-section-product-template .product-single__classic-title'));
  //mobile carousel
  $(".js-related-products").each(function(i) {
	var thisSectionId = $(this).data("section-id");
		theme.layoutSlider(".js-layout-slider-" + thisSectionId);
  });
});